import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import NuiAdminConsoleActivity from './nuiAdminConsoleActivity';
import NuiAdminConsolePayments from './nuiAdminConsolePayments';
import NuiAdminConsoleUsers from './nuiAdminConsoleUsers';
import NuiAdminConsoleChats from './nuiAdminConsoleChats';
import { ThemeProvider } from '@mui/material/styles';

import {robotaxmakerTheme} from './nuiCommon/nuiRobotaxmakerTheme';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function NuiAdminConsoleTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <ThemeProvider theme={robotaxmakerTheme}>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', position: 'relative' }}>
          <Tabs value={value} onChange={handleChange} centered>
            <Tab label="Все действия" {...a11yProps(0)} />
            <Tab label="Платежи" {...a11yProps(1)} />
            <Tab label="Пользователи" {...a11yProps(2)} />
            <Tab label="Диалоги чата" {...a11yProps(3)} />
          </Tabs>
          <Button
            variant="outlined"
            size="small"
            endIcon={<OpenInNewIcon/>}
            href="/api/support/draftWebApp"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)' }}
          >
            Черновик ответа
          </Button>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <NuiAdminConsoleActivity/>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <NuiAdminConsolePayments/>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <NuiAdminConsoleUsers/>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={3}>
          <NuiAdminConsoleChats/>
        </CustomTabPanel>
      </Box>
    </ThemeProvider>);
}
